import React from "react";

import Helmet from "react-helmet";
import Breadcrumbs from "../components/breadcrumbs";

const ContactPage = () => (
  <React.Fragment>
    <Helmet>
      <title>Contact</title>
    </Helmet>

    {/* <Breadcrumbs crumbs={[{ "Sign Awning": "/" }, "Contact"]} /> */}

    <header>
      <h2>Contact</h2>
    </header>

    <p>
      If you are interested in our services, please call us or send us an email:
    </p>

    <p>Phone: 415-386-3333</p>

    <p>iPhone: 415-948-6000</p>

    <p>Email: bob@signawning.com</p>
  </React.Fragment>
);

export default ContactPage;



// WEBPACK FOOTER //
// ./src/pages/contact.js